<template>
  <div class="container-fluid mt-4 px-1">
    <div class="row gx-3"> 
      <div class="col-md-4">
        <ranking-list-card
          :horizontal-break="false"
          :card="{
            title: '이벤트 데이터',
          }"
          :item="dataList"
        >
        </ranking-list-card>
      </div>


      <div class="col-md-4">
        <div class="card shadow-sm p-4 h-100" style="width: 100%;">
              <div class="col-md-6">
                <h6 class="pb-4 mb-0">입력 데이터</h6>
              </div>
          <form @submit.prevent="submitEvent">
            <!-- 원재료 선택 -->
            <div class="mb-3">
              <label for="epc" class="form-label">포장제품 선택</label>
              <select v-model="epc" class="form-select" id="epc" >
                <option value="">선택</option>
                <option v-for="item in combinedList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 스캔장소 (readPoint) -->
            <div class="mb-3">
              <label for="readPoint" class="form-label">스캔장소 (readPoint)</label>
              <select v-model="form.readPoint.manualURI" class="form-select" id="readPoint">
                <option value="">선택</option>
                <option v-for="item in readPointList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 입고장소 (bizLocation) -->
            <div class="mb-3">
              <label for="bizLocation" class="form-label">운송장소 (bizLocation)</label>
              <select v-model="form.bizLocation.manualURI" class="form-select" id="bizLocation">
                <option value="">선택</option>
                <option v-for="item in bizLocationList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 수량 -->
            <div class="mb-3">
              <div class="row">
              <div class="col-7">
                <label for="vehicle" class="form-label">운송수단</label>
                <select v-model="form.extensions.vehicleNumber" class="form-select" id="vehicle">
                  <option value="">선택</option>
                  <option v-for="item in vehicleList" :key="item.vehicleNo" :value="item.vehicleNo">
                     {{item.vehicleNo }} ({{item.fuelType}})
                  </option>
                </select>
              </div>
              <div class="col-5">
                <label for="emission" class="form-label">탄소배출량</label>
                <div class="input-group">
                  <input type="text" class="form-control bg-white text-end" :value="form.extensions.carbonEmission" id="emission" readonly/>
                  <span class="input-group-text">kgCO₂</span>
                </div>
              </div>
              </div>
            </div>

            <div class="mb-3">
              <label for="eventTime" class="form-label">이벤트 발생 시간</label>
              <input type="datetime-local" v-model="eventTimeTemp" class="form-control" id="eventTime" />
            </div>

            <!-- 등록 버튼 -->
            <div class="text-end">
              <button type="submit" class="btn btn-success">이벤트 등록</button>
            </div>
          </form>
        </div>
      </div>
      
      <div class="col-md-4">
        <div class="card shadow-sm p-4 h-100" style="width: 100%;">
          <div class="col-md-6">
            <h6 class="pb-4 mb-0">거리정보</h6>
          </div>
          <div class="p-1">
            <map-distance
              v-model:pointA="ptA"
              v-model:pointB="ptB"
              :center="mapCenter"
              :pointAName="'출고'"
              :pointBName="'도착'"
              :draggable="true"
              :fitOnUpdate="!!ptB"
              :height="'480px'"
            />
          </div>
        </div>
      </div>
    </div>

    <EventListTable
      :eventList="recentEventList"
      :loading="loadingEvents"
      :minBodyHeight="300"
      emptyMessage="최근 이벤트가 없습니다."
    />
  </div>
</template>
<script>
import { fetchBizLocationData, fetchReadPointData, fetchBoxData, fetchVehicleData } from "../../api/common/initDataAPI";
import { pollEpcisEvent, saveBlockChain } from "@/api/common/blockchain.js";
import RankingListCard from "@/examples/Cards/RankingListCard.vue";
import EventListTable from "@/views/components/EventListTable.vue";
import MapDistance from "@/components/map/mapDistance.vue";
import api from '@/api/api';

export default {
  name: "EventPrc7",
  components: {
    RankingListCard,
    EventListTable,
    MapDistance,
  },
  inject: ['showLoading', 'hideLoading'],
  computed: {
    mfId() {
      return this.$store.getters['UserStore/getMfId'];
    },
    dataList() {
      return [{
        title: '이벤트타입',
        date: 'EventType',
        amount: 'ObjectEvent',
        icon: 'fa-info',
        color: 'dark',
      },
      {
        title: '액션',
        date: 'Action',
        amount: 'ADD',
        icon: 'fa-info',
        color: 'dark',
      },
      {
        title: '업무단계',
        date: 'bizStep',
        amount: 'TRANSPORTING',
        icon: 'fa-info',
        color: 'dark',
      },
      {
        title: '처리상태',
        date: 'Disposition',
        amount: 'IN_TRANSIT',
        icon: 'fa-info',
        color: 'dark',
      }
      ]
    },
    mapCenter() {
      const mfInfo = this.$store.getters["UserStore/getMfInfo"];
      if (mfInfo?.lat && mfInfo?.lng) {
        return [mfInfo.lat, mfInfo.lng];
      }
      return [35.8714354, 128.601445]; // 기본 좌표
    },
  },
  watch: {
    epc: {
      immediate: false,
      async handler(newVal) {
        if (!newVal) {
          this.ptA = null;              // ★ 선택 해제 시 지도 좌표도 초기화
          this.recalcCarbonEmission();   // 배출량도 다시 0으로
          return;
        }
        try {
          const { data } = await api.get('/opensearch/readPoint', {
            params: {
              mfId: this.mfId,
              eventType: 'ObjectEvent',
              bizStep: 'shipping',
              epc: newVal
            }
          });
          const urn = data?.result?.readPoint || '';
          if (!urn) {
            this.toastError?.('해당 EPC의 출고 readPoint를 찾지 못했습니다.');
            this.ptA = null;
            return;
          }
          const coords = this.findReadPointCoordsByUrn(urn);
          if (coords) {
            this.ptA = coords;
          } else {
            this.toastError?.('출고 readPoint가 위치정보(lat/lng)를 가지고 있지 않습니다.');
            this.ptA = null;
          }
          this.recalcCarbonEmission();
        } catch (e) {
          console.error(e);
          this.toastError?.('출고 readPoint 조회 중 오류가 발생했습니다.');
          this.ptA = null;
        }
      }
    },
    'form.readPoint.manualURI'(urn) {
      if (!urn) {
        this.ptB = null;                // ★ 이미 이렇게 되어 있어 OK
        this.recalcCarbonEmission();
        return;
      }
      const coords = this.findReadPointCoordsByUrn(urn);
      if (coords) {
        this.ptB = coords;
      } else {
        this.toastError?.('선택한 스캔장소에 위치정보가 없습니다.');
        this.ptB = null;
      }
      this.recalcCarbonEmission();

      const sel = this.readPointList.find(r => r.urn === urn);
      if (sel && sel.blId != null) {
        const bl = this.bizLocationList.find(b => b.id === sel.blId);
        if (bl) this.form.bizLocation.manualURI = bl.urn;
      }
    },
    'form.extensions.vehicleNumber'() {
      this.recalcCarbonEmission();
    },
    ptB() {
      this.$watch('form.extensions.vehicleNumber', (val) => {
        if (val) this['form.extensions.vehicleNumber'] = val; // 강제로 다시 계산
      }, { immediate: true });
    }
  },
  data() {
    return {
      loadingEvents: true,
      epc: '',
      crtEventID: '', 
      eventTimeTemp: '',
      form: {
        parentID: '',
        childEPCs: [],
        eventType: "ObjectEvent",
        action: 'ADD',
        businessStep: 'TRANSPORTING',
        disposition: 'IN_TRANSIT',
        eventTimeSelector: '',
        eventTime: {},
        quantity: '1',
        epcList: [],
        readpointselector: 'manually',
        readPoint: {
          gcpLength: null,
          manualURI: "",
        },
        businesslocationselector: "manually",
        bizLocation: {
          gcpLength: null,
          manualURI: "",
        },
        vocabularySyntax: 'URN',
        ordinaryEvent: true,
        RecordTimeOption: 'no',
        recordTimeType: 'SAME_AS_EVENT_TIME',
        PersistentDispositionType: null,
        PersistentDisposition: null,
        persistentDispositionCount: 0,
        persistentDispositionList: [],
        businessTransactionCount: 0,
        businessTransactionList: [],
        errorCorrectiveCount: 0,
        errorCorrectiveIdsList: [],
        eventID: false,
        eventIdType: 'UUID',
        hashAlgorithm: 'sha-256',
        extensions: {
          vehicleNumber: '',
          carbonEmission: 0,
        },
      },
      productList: [],
      combinedList: [],
      bizLocationList: [],
      readPointList: [],
      eventEpcList: [],
      vehicleList: [],

      recentEventList: [],
      ptA: null,
      ptB: null,
    }
  },
  async mounted() {
    this.eventTimeTemp = this.setDefaultTime();

    let now = new Date()
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset())
    now.setSeconds(now.getSeconds(), 0)
    now = now.toISOString().slice(0, -1)

    this.form.eventTime = {
      specificTime: now,
      fromTime: now,
      toTime: now,
      timeZoneOffset: '+09:00'
    }

    this.$store.state.DesignTestDataStore.eventType = "ObjectEvent";
    
    const [bizList, readList, boxList, carList] = await Promise.all([
      fetchBizLocationData(this.mfId),
      fetchReadPointData(this.mfId),
      fetchBoxData(this.mfId),
      fetchVehicleData(this.mfId),
    ]);
    this.bizLocationList = bizList;
    this.readPointList   = readList;
    this.productList   = boxList;
    this.vehicleList = carList;

    await this.fetchProductEventData();
    this.fetchEventListData();
  },
  methods: {
    async fetchProductEventData() {
      try {
        const response = await api.get(`/opensearch/productList?eventType=ObjectEvent&bizStep=shipping&mfId=${this.mfId}`);

        const result = response.data.result;
        this.eventEpcList = result.productList;

        this.combineLists();
      } catch (error) {
        console.error("정보 불러오기 실패:", error);
      }
    },
    combineLists() {
      this.combinedList = this.eventEpcList.map(urn => {
        const baseUrn = urn.split('.').slice(0, -1).join('.');
        const matchedProduct = this.productList.find(rm => rm.urn === baseUrn);
        return {
          name: matchedProduct ? matchedProduct.name : "알 수 없음",
          urn: urn
        };
      });
    },
    async submitEvent() {
      this.form.eventTime = this.syncEventTimeFromTemp(this.eventTimeTemp);
      this.showLoading?.('이벤트를 EPCIS에 저장중...');
      try {
        this.form.epcList = [this.epc];

        // 템플릿 채우기
        this.$store.dispatch('TestDataJsonPreparator/jsonPreparation', { formData: this.form });
        this.$store.commit(
          'TestDataGeneratorStore/populateTestDataInput',
          JSON.stringify(this.$store.state.TestDataJsonPreparator.testDataInputTemplate)
        );
        await this.$store.dispatch('TestDataGeneratorStore/testdataGenerator');
        const dataResult = JSON.stringify(this.$store.state.TestDataGeneratorStore.testDataOutput, null, 2);

        // ✅ EPCIS 캡처
        const cap = await this.captureApi(dataResult);
        if (!cap.success) throw new Error(cap.error || 'EPCIS 캡처 실패');

        // ✅ EPCIS 폴링
        const committedEvent = await pollEpcisEvent(this.crtEventID, {
          timeout: 60000, startInterval: 800, maxInterval: 4000
        });
        
        this.showLoading?.('이벤트를 블록체인에 저장중...');

        // ✅ 블록체인 저장
        await saveBlockChain(this.crtEventID, committedEvent, 60000);

        this.toastSuccess?.("저장 되었습니다.");
        setTimeout(() => this.fetchEventListData(), 2000);
      } catch (e) {
        console.error(e);
        this.toastError?.(e.message || '처리 중 오류 발생');
      } finally {
        this.hideLoading?.();
      }
    },
    async captureApi(dataResult) {
      try {
        const jsonData = JSON.parse(dataResult);
        const event = jsonData.epcisBody.eventList[0];

        event["cbv:extension"] = { companyPrefix: this.mfId };
        if (this.form.extensions.vehicleNumber) {
          event["cbv:extension"].vehicleNumber = this.form.extensions.vehicleNumber;
        }
        if (this.form.extensions.carbonEmission && this.form.extensions.carbonEmission !== "0") {
          event["cbv:extension"].carbonEmission = this.form.extensions.carbonEmission;
        }

        event.epcList = this.form.epcList;
        delete event.parentID;
        delete event.childEPCs;

        // eventID 강제 생성
        if (!event.eventID) {
          const id = crypto?.randomUUID?.() || (Date.now().toString(36) + Math.random().toString(36).slice(2));
          this.crtEventID = `urn:uuid:${id}`;
          event.eventID = this.crtEventID;
        } else {
          this.crtEventID = event.eventID;
        }

        const resp = await fetch(`/api/epcisAPI/capture`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(jsonData),
        });
        if (!resp.ok) throw new Error("응답 오류: " + resp.status);

        const text = await resp.text();
        const result = text ? JSON.parse(text) : {};
        return { success: true, data: result };
      } catch (e) {
        console.error('전송 실패:', e);
        return { success: false, error: e.message || e };
      }
    },
    async fetchEventListData() {
      this.loadingEvents = true;
      try {

        const [res] = await Promise.all([
          api.get(`/event/list`, {
            params: { 
              mfId: this.mfId,
              eventType: this.form.eventType,
              bizStep: this.form.businessStep.toLowerCase(),
              disposition: this.form.disposition.toLowerCase()
            }
          }),
          new Promise(r => setTimeout(r, 600))
        ]);

        const result = res.data.result;
        this.recentEventList = result.recentEventList || [];
      } catch (error) {
        console.error("정보 불러오기 실패:", error);
      } finally {
        this.loadingEvents = false;
      }
    },
    findReadPointCoordsByUrn(urn) {
      const rp = this.readPointList.find(x => x.urn === urn);
      if (rp && rp.lat != null && rp.lng != null) {
        return [Number(rp.lat), Number(rp.lng)];
      }
      return null;
    },
    recalcCarbonEmission() {
      const vNo = this.form.extensions.vehicleNumber;
      if (!vNo || !this.ptA || !this.ptB) {
        this.form.extensions.carbonEmission = "0";
        return;
      }

      // 차량정보 찾기 (select value가 vehicleNo)
      const vehicle = this.vehicleList.find(v => v.vehicleNo === vNo);
      if (!vehicle || !vehicle.fuelEfficiency || !vehicle.emissionPerKm) {
        this.form.extensions.carbonEmission = "0";
        return;
      }

      // 거리계산 (Leaflet)
      const a = L.latLng(this.ptA[0], this.ptA[1]);
      const b = L.latLng(this.ptB[0], this.ptB[1]);
      const distKm = a.distanceTo(b) / 1000; // km

      // 배출량 계산
      const totalEmission = distKm * Number(vehicle.emissionPerKm);
      this.form.extensions.carbonEmission = totalEmission > 0 ? totalEmission.toFixed(2) : "0";
    },
  },
};
</script>
